import './dashboardOverView.css'
import {ReactElement} from "react";

export function DashboardOverView(props: { children: ReactElement[] }) {

    return (
        <div className={"kpi-overview"}>
            {props.children}
        </div>
    )
}
